export enum E_MEDIA_TYPES {
  video = 'video',
  image = 'image',
  svg = 'svg'
}

export enum E_VIDEO_MIME_TYPES {
  mp4 = 'video/mp4',
  mpg = 'video/mpeg',
  ogg = 'video/ogg',
  webm = 'video/webm'
}
